module.exports = __webpack_public_path__ + "img/residence-g597d70b1d_1920.d88c7bae.jpg";